import React, { useEffect } from 'react'
import { Button, Nav  } from 'react-bootstrap'
import NavBarVertical from '../components/NavBarVertical'

import { Outlet, redirect, useLoaderData, useNavigate, useParams   } from 'react-router-dom';
import { get_publications_types} from '../api';
import { is_authenticated, auth_delete } from '../module/auth.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';


export const loader = async () => {

  try{

    if(!is_authenticated()){
      return redirect("/login");
    }

    const response = await get_publications_types();
    return {data:response,error:null};

  }
  catch(error){ 

    if(error.status === 401){
      auth_delete();
      return redirect("/login");
    }

    return {data:null,error:error};
  }
}


function DigitalPublications() {

  const response = useLoaderData();
  const navigate = useNavigate();
  let { category } = useParams();

  const HOVER_CLASS = ["bg-primary-subtle","text-primary-emphasis"];
  const SELECT_CLASS = ["bg-primary","bs-primary-rgb","text-white"];
  const DEFAULT_CLASS = ["p-3"];

  const [links,set_links] = React.useState([]);
  const [selected,set_selected] = React.useState(0); // [id1,id2,id3,id4,id5,id6,id7
  const [selected_url,set_selected_url] = React.useState("");

  const on_click = (id,url)=>{
    
    navigate(`/digital_publications/${url}/1`);
    set_selected(id); set_selected_url(url);

  }
  
  const on_hover_out = (id)=>{

    set_links((prev_links)=>{

      const link_aux = prev_links.map(link=>{
        if(link.id === id && selected !== id){
          link.class = [];
        }
        return link;
      })

      return link_aux;

    })
  }

  const on_hover_in = (id)=>{

    set_links((prev_links)=>{
      
      return prev_links.map((link)=>{
 
        if(link.id === id && selected !== id){
          link.class = HOVER_CLASS.concat(link.class);
        }
        return link;
 
      })
  })  

  }

  useEffect(()=>{

    set_links((prev_links)=>{

      const link_aux = prev_links.map(link=>{

        if(link.id === selected){
          link.class = SELECT_CLASS.concat(DEFAULT_CLASS);
        }
        else{
          link.class = DEFAULT_CLASS;
        }
        return link;
      })

      return link_aux;

    })
  
    // eslint-disable-next-line
  },[selected]);

  useEffect(()=>{

    if(response !== undefined){
      if(response.error === null){
        set_links(()=>{

          return response.data.map((link,index)=>{ 
            return {
              "id":link.id,
              "text":link.text,
              "href":`${link.url}`,
              "hover":false,
              "class":DEFAULT_CLASS,
              "selected":selected === link.id
            }
            });
        });
      }
      else{
        set_links([]);
      }
    }
    
  // eslint-disable-next-line
  },[response]);

  useEffect(()=>{
  
    const defaultSelect = links.find(x => x.href === category);

    if(defaultSelect !== undefined && defaultSelect !== null){
      set_selected(defaultSelect.id)
      set_selected_url(category);
    }
   
  // eslint-disable-next-line
  },[links]);

  return (
  <>
    <NavBarVertical title_menu={selected_url}>
        <NavBarVertical.Menu>
           
        <Nav defaultActiveKey="/home" className="flex-column">
          {
            links.map((link)=>{
              return (
                <Nav.Link key={link.id} className={`${link.class.join(" ")} ${DEFAULT_CLASS.join(" ")}`} onMouseLeave={()=>on_hover_out(link.id)} onMouseEnter={()=>on_hover_in(link.id)} onClick={()=>on_click(link.id,link.href)}>{link.text}</Nav.Link>) 
            })
          }

        </Nav> 

        <Button variant="outline-secondary" className='d-table ms-auto me-auto m-3' onClick={()=>navigate("/")}>
            <FontAwesomeIcon icon= { faArrowLeft }/>  Home
        </Button>

        </NavBarVertical.Menu>
        <NavBarVertical.Content>
          <Outlet />
        </NavBarVertical.Content>
 
    </NavBarVertical>
  </>
)}

export default DigitalPublications